import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import SideMenu from '../../../components/SideMenu';
import Quotes from '../../../components/Quotes';
import Footer from '../../../components/Footer';
import ToggleButton from '../../../components/ToggleButton';

import SubUsersManagerService from '../../../services/Celcoin/subUsersManagerService';
import { getTranslations } from '../../../services/languageUtils';

class Page extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      translations: {},
      users: [],
      newUser: {
        name: '',
        email: '',
        password: '',
        pin: '',
        enablePix: false,
        enableTed: false,
        enableBoleto: false,
      },
    };
  }

  componentDidMount() {
    this.loadTranslations();
    this.loadUsers();
  }

  loadTranslations = async () => {
    const language = localStorage.getItem('language') || 'pt';
    const translations = await getTranslations(language);
    this.setState({ translations });
  };

  loadUsers = async () => {
    try {
      const email = sessionStorage.getItem('emailUser');
      const response = await SubUsersManagerService.indexUsers({ email });
      this.setState({ users: response.data.message });
    } catch (error) {
      this.showToast(this.state.translations.errorSearchUsers, 'error');
    }
  };

  addUser = async () => {
  };

  updateUser = async (user) => {
  };

  destroyUser = async (email) => {
  };

  renderUserList() {
    const { users, translations } = this.state;
    return users.map((user, index) => (
      <li key={index} className="user-item">
        <span>{user.email}</span>
        <input
          type="text"
          className="input-field"
          value={user.name}
          onChange={(e) => {
            const updatedUsers = [...users];
            updatedUsers[index] = { ...user, name: e.target.value };
            this.setState({ users: updatedUsers });
          }}
        />
        <div style={{display: "flex", marginTop: "5px"}}>
          <ToggleButton onChange={(state) => (user.enablePix = state)} defaultChecked={user.enablePix} />
          <span style={{marginTop: "-5px"}}>&nbsp;&nbsp;{this.state.translations.pixAccess}</span>
        </div>

        <div style={{display: "flex", marginTop: "5px"}}>
          <ToggleButton onChange={(state) => (user.enableTed = state)} defaultChecked={user.enableTed} />
          <span style={{marginTop: "-5px"}}>&nbsp;&nbsp;{this.state.translations.tedAccess}</span>
        </div>

        <div style={{display: "flex", marginTop: "5px"}}>
          <ToggleButton onChange={(state) => (user.enableBoleto = state)} defaultChecked={user.enableBoleto} />
          <span style={{marginTop: "-5px"}}>&nbsp;&nbsp;{this.state.translations.ticketAccess}</span>
        </div>

        <div style={{display: "flex", marginTop: "5px"}}>
          <div onClick={() => this.updateUser(user)} className="destroyButton" style={{margin: "15px 0px 10px 0px", padding: "10px", backgroundColor: "#1c787e"}}>{translations.update}</div>
          <div onClick={() => this.destroyUser(user.email)} className="deactivateButton" style={{margin: "15px 0px 10px 0px", padding: "10px"}}>{translations.remove}</div>
        </div>
      </li>
    ));
  }

  render() {
    const { translations, newUser } = this.state;
    return (
      <section id="userPage" className="userPage transactionPage statementPage">
        <SideMenu />

        <div className="contentData">
          <div className="contentScroll">
            <Quotes />
            <p className="breadcrumb"><b><span className="textPrimary">{this.state.translations.home} </span> | {this.state.translations.managerUsers} </b></p><br/>
            <p className="title"><span style={{fontWeight: "normal"}}></span> {this.state.translations.managerUsers} </p><br/>

          <p className="title" style={{fontSize: "18px"}}>{translations.listUsers}</p>
          <br/>
            <ul className="user-list">{this.renderUserList()}</ul>
          
          <p className="title" style={{fontSize: "18px"}}>{translations.newUser}</p>
          <br/>
            <div className="form-group">
              <input
                type="text"
                className="input-field"
                placeholder={translations.name}
                value={newUser.name}
                onChange={(e) => this.setState({ newUser: { ...newUser, name: e.target.value } })}
              />
              <input
                type="email"
                className="input-field"
                placeholder={translations.email}
                value={newUser.email}
                onChange={(e) => this.setState({ newUser: { ...newUser, email: e.target.value } })}
              />
              <input
                type="number"
                className="input-field"
                placeholder={translations.pin}
                value={newUser.pin}
                onChange={(e) => this.setState({ newUser: { ...newUser, pin: e.target.value } })}
              />
              <input
                type="password"
                className="input-field"
                placeholder={translations.userPassword}
                value={newUser.password}
                onChange={(e) => this.setState({ newUser: { ...newUser, password: e.target.value } })}
              />
              <div style={{display: "flex", marginTop: "5px"}}>
                <ToggleButton
                  onChange={(state) => this.setState({ newUser: { ...newUser, enablePix: state } })}
                  defaultChecked={newUser.enablePix}
                />
                <span style={{marginTop: "-5px"}}>&nbsp;&nbsp;{this.state.translations.enablePix}</span>
              </div>

              <div style={{display: "flex", marginTop: "5px"}}>
                <ToggleButton
                  onChange={(state) => this.setState({ newUser: { ...newUser, enableTed: state } })}
                  defaultChecked={newUser.enableTed}
                />
                <span style={{marginTop: "-5px"}}>&nbsp;&nbsp;{this.state.translations.enableTed}</span>
              </div>

              <div style={{display: "flex", marginTop: "5px"}}>
                <ToggleButton
                  onChange={(state) => this.setState({ newUser: { ...newUser, enableBoleto: state } })}
                  defaultChecked={newUser.enableBoleto}
                />
                <span style={{marginTop: "-5px"}}>&nbsp;&nbsp;{this.state.translations.enableTicket}</span>
              </div>
            </div>
            <div className="destroyButton" style={{margin: "15px 0px 10px 0px", padding: "10px", backgroundColor: "#1c787e"}} onClick={this.addUser}>{translations.add}</div>
          </div>
          <Footer />
        </div>
        <ToastContainer />
      </section>
    );
  }
}

export default Page;